// extracted by mini-css-extract-plugin
export var alt = "VideoPlayer-module--alt--16e6c";
export var container = "VideoPlayer-module--container--a7a1b";
export var desktopOnly = "VideoPlayer-module--desktopOnly--6dd5b";
export var main = "VideoPlayer-module--main--3810e";
export var mobileOnly = "VideoPlayer-module--mobileOnly--4a5c6";
export var player = "VideoPlayer-module--player--43a34";
export var textLeft = "VideoPlayer-module--textLeft--35349";
export var visuallyHidden = "VideoPlayer-module--visuallyHidden--69f4f";